import { render } from "./imgTag.vue?vue&type=template&id=77a95c31"
import script from "./imgTag.vue?vue&type=script&lang=js"
export * from "./imgTag.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__